<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="memberData === null">Create Member Profile</span>
      <span v-else>Update Member Profile</span>
    </h6>

    <form id="form-proper">
      <div v-if="!quickRegistration">
        <a-spin tip="Please wait ..." :spinning="formLoading">
          <div>
            <a-steps
              :current="currentStep"
              style="border-bottom: 1px solid #e0e0e0"
              class="py-2 mb-3"
              size="small"
            >
              <a-step title="Member Profile" />
              <a-step title="Personal Info" />
              <a-step title="Address" />
              <a-step title="Contact" />
              <a-step title="Subscribe to Marketing" />
              <a-step v-if="dynamic_form.length > 0" title="Other Info" />
            </a-steps>

            <!-- Personal Info Tab -->
            <div v-if="currentStep == 1">
              <base-input label="First Name" required>
                <masked-input
                  id="first_name"
                  v-model.trim="$v.formData.first_name.$model"
                  :viewMode="viewMode"
                  :disabled="viewMode"
                  @blur="checkDataDiff"
                  :maskFn="maskString"
                />
                <!-- <a-input
                  id="first_name"
                  v-model.trim="maskedForm.first_name"
                  :disabled="viewMode"
                  @blur="checkDataDiff"
                /> -->
                <div v-if="$v.formData.first_name.$dirty" class="text-danger">
                  <div class="error" v-if="!$v.formData.first_name.required">
                    Field is required
                  </div>
                </div>
              </base-input>

              <base-input label="Middle Name">
                <masked-input
                  id="middle_name"
                  v-model.trim="formData.middle_name"
                  :viewMode="viewMode"
                  :disabled="viewMode"
                  @blur="checkDataDiff"
                  :maskFn="maskString"
                />
                <!-- <a-input
                  id="middle_name"
                  v-model="formData.middle_name"
                  :disabled="viewMode"
                  @blur="checkDataDiff"
                /> -->
              </base-input>

              <base-input label="Last Name" required>
                <masked-input
                  id="last_name"
                  v-model.trim="$v.formData.last_name.$model"
                  :viewMode="viewMode"
                  :disabled="viewMode"
                  @blur="checkDataDiff"
                  :maskFn="maskString"
                />
                <!-- <a-input
                  id="last_name"
                  v-model.trim="$v.formData.last_name.$model"
                  :disabled="viewMode"
                  @blur="checkDataDiff"
                /> -->
                <div v-if="$v.formData.last_name.$dirty" class="text-danger">
                  <div class="error" v-if="!$v.formData.last_name.required">
                    Field is required
                  </div>
                </div>
              </base-input>

              <div class="row">
                <div class="col">
                  <base-input label="Last Name Suffix">
                    <masked-input
                      id="last_name_suffix"
                      v-model.trim="formData.last_name_suffix"
                      :viewMode="viewMode"
                      :disabled="viewMode"
                      @blur="checkDataDiff"
                      :maskFn="maskString"
                    />
                    <!-- <a-input
                      id="last_name_suffix"
                      v-model="formData.last_name_suffix"
                      :disabled="viewMode"
                      @blur="checkDataDiff"
                    /> -->
                  </base-input>
                </div>

                <div class="col">
                  <base-input label="Nickname">
                    <masked-input
                      id="nick_name"
                      v-model.trim="formData.nick_name"
                      :viewMode="viewMode"
                      :disabled="viewMode"
                      @blur="checkDataDiff"
                      :maskFn="maskString"
                    />
                    <!-- <a-input
                      id="nick_name"
                      v-model="formData.nick_name"
                      :disabled="viewMode"
                      @blur="checkDataDiff"
                    /> -->
                  </base-input>
                </div>
              </div>

              <base-input label="Gender" :required="isMandatoryField('gender')">
                <a-select
                  id="gender"
                  :disabled="viewMode"
                  v-model="formData.gender"
                  @blur="checkDataDiff"
                >
                  <a-select-option
                    v-for="gender in options.genders"
                    :key="gender.key"
                    :value="gender.key"
                  >
                    {{ gender.name }}
                  </a-select-option>
                </a-select>
                <div v-if="isMandatoryField('gender')">
                  <div v-if="$v.formData.gender.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.gender.required">
                      Field is required
                    </div>
                  </div>
                </div>
              </base-input>

              <base-input label="Birthdate">
                <div class="row">
                  <div class="col-4 col-sm-4 col-md-4 col-lg-4">
                    <a-select
                      id="birth_month"
                      v-model="birthMonth"
                      :disabled="disableBirthMonth"
                      @change="checkDataDiff('birth_month')"
                      :required="isMandatoryField('birth_month')"
                    >
                      <a-select-option
                        v-for="month in options.months"
                        :key="month.key"
                        :value="month.key"
                      >
                        {{ viewMode ? maskString(month.name) : month.name }}
                      </a-select-option>
                    </a-select>
                    <small class="text-muted">
                      <i>Month</i>
                      <span
                        class="text-danger"
                        v-if="isMandatoryField('birth_month')"
                        >*</span
                      >
                      <br />
                      <div v-if="isMandatoryField('birth_month')">
                        <div v-if="$v.birthMonth.$dirty" class="text-danger">
                          <div class="error" v-if="!$v.birthMonth.required">
                            Field is required
                          </div>
                        </div>
                      </div>
                    </small>
                  </div>
                  <!-- /
                  <div class="col-4 col-sm-4 col-md-3 col-lg-3">
                    <a-select
                      id="birth_day"
                      v-model="birthDay"
                      :disabled="disableBirthDay"
                      @change="checkDataDiff('birth_day')"
                      :required="isMandatoryField('birth_day')"
                    >
                      <a-select-option
                        v-for="day in bdayValidDays"
                        :key="zeroPad(day, 2)"
                        :value="zeroPad(day, 2)"
                      >
                        {{
                          viewMode
                            ? maskString(zeroPad(day, 2))
                            : zeroPad(day, 2)
                        }}
                      </a-select-option>
                    </a-select>
                    <small class="text-muted">
                      <i>Day</i>
                      <span
                        class="text-danger"
                        v-if="isMandatoryField('birth_day')"
                        >*</span
                      >
                      <br />
                      <div v-if="isMandatoryField('birth_day')">
                        <div v-if="$v.birthDay.$dirty" class="text-danger">
                          <div class="error" v-if="!$v.birthDay.required">
                            Field is required
                          </div>
                        </div>
                      </div>
                    </small>
                  </div>
                  / -->
                  <div class="col-4 col-sm-4 col-md-4 col-lg-4">
                    <div v-if="viewMode">
                      <masked-input
                        v-model="birthYear"
                        :viewMode="viewMode"
                        :disabled="viewMode"
                        @blur="checkDataDiff('birth_year')"
                        :maskFn="maskString"
                      />
                    </div>
                    <div v-else>
                      <a-select
                        id="birth_year"
                        v-model="birthYear"
                        :disabled="disableBirthYear"
                        @change="checkDataDiff('birth_year')"
                        :required="isMandatoryField('birth_year')"
                      >
                        <a-select-option
                          v-for="year in 101"
                          :key="parseInt(yearStart) + parseInt(year)"
                          :value="parseInt(yearStart) + parseInt(year)"
                        >
                          {{ parseInt(yearStart) + parseInt(year) }}
                        </a-select-option>
                      </a-select>
                    </div>
                    <small class="text-muted">
                      <i>Year</i>
                      <span
                        class="text-danger"
                        v-if="isMandatoryField('birth_year')"
                        >*</span
                      >
                      <br />
                      <div v-if="isMandatoryField('birth_year')">
                        <div v-if="$v.birthYear.$dirty" class="text-danger">
                          <div class="error" v-if="!$v.birthYear.required">
                            Field is required
                          </div>
                        </div>
                      </div>
                    </small>
                  </div>
                </div>
              </base-input>
            </div>
            <!-- /Personal Info Tab -->

            <!-- Address Tab -->
            <div v-if="currentStep == 2">
              <base-input
                label="Region"
                :required="isMandatoryField('location_region')"
              >
                <div v-if="viewMode">
                  <!-- <a-input placeholder="" v-model="location_region" disabled /> -->
                  <masked-input
                    v-model="location_region"
                    :viewMode="viewMode"
                    :disabled="viewMode"
                    @blur="checkDataDiff"
                    :maskFn="maskString"
                  />
                </div>
                <div v-else>
                  <a-select
                    id="location_region"
                    :disabled="viewMode"
                    v-model="formData.region_code"
                    @change="
                      () => {
                        onChangeRegion();
                        checkDataDiff('location_region');
                      }
                    "
                    show-search
                    optionFilterProp="children"
                  >
                    <a-select-option
                      v-for="region in options.regions"
                      :key="region.code"
                      :value="region.code"
                    >
                      {{ region.regionName }} - {{ region.name }}
                    </a-select-option>
                  </a-select>
                  <div v-if="isMandatoryField('location_region')">
                    <div
                      v-if="
                        $v.formData.region_code.$dirty ||
                        $v.formData.location_region.$dirty
                      "
                      class="text-danger"
                    >
                      <div
                        class="error"
                        v-if="
                          !$v.formData.region_code.required ||
                          !$v.formData.location_region.required
                        "
                      >
                        Field is required
                      </div>
                    </div>
                  </div>
                </div>
              </base-input>

              <base-input
                label="Province"
                v-if="!isRegionNCR"
                :required="isMandatoryField('location_province')"
              >
                <div v-if="viewMode">
                  <!-- <a-input
                    placeholder=""
                    v-model="location_province"
                    disabled
                  /> -->

                  <masked-input
                    v-model="location_province"
                    :viewMode="viewMode"
                    :disabled="viewMode"
                    @blur="checkDataDiff"
                    :maskFn="maskString"
                  />
                </div>
                <div v-else>
                  <a-select
                    id="location_province"
                    :disabled="viewMode"
                    v-model="formData.province_code"
                    @change="
                      () => {
                        onChangeProvince();
                        checkDataDiff('location_province');
                      }
                    "
                    show-search
                    optionFilterProp="children"
                  >
                    <a-select-option
                      v-for="province in options.provinces"
                      :key="province.code"
                      :value="province.code"
                      :data-region_code="province.regionCode"
                    >
                      {{ province.name }}
                    </a-select-option>
                  </a-select>
                  <div v-if="isMandatoryField('location_province')">
                    <div
                      v-if="
                        ($v.formData.province_code &&
                          $v.formData.province_code.$dirty) ||
                        ($v.formData.location_province &&
                          !$v.formData.location_province.required)
                      "
                      class="text-danger"
                    >
                      <div
                        class="error"
                        v-if="
                          !$v.formData.province_code.required ||
                          !$v.formData.location_province.required
                        "
                      >
                        Field is required
                      </div>
                    </div>
                  </div>
                </div>
              </base-input>

              <base-input
                label="City/Municipality"
                :required="isMandatoryField('location_city')"
              >
                <div v-if="viewMode">
                  <!-- <a-input placeholder="" v-model="location_city" disabled /> -->
                  <masked-input
                    v-model="location_city"
                    :viewMode="viewMode"
                    :disabled="viewMode"
                    @blur="checkDataDiff"
                    :maskFn="maskString"
                  />
                </div>
                <div v-else>
                  <a-select
                    id="location_city"
                    :disabled="viewMode"
                    v-model="municity"
                    @change="onChangeCity()"
                    show-search
                    optionFilterProp="children"
                  >
                    <a-select-option
                      v-for="city in options.cities"
                      :data-city="String(city.isCity)"
                      :key="city.code"
                      :value="city.code"
                    >
                      {{ city.name }}
                    </a-select-option>
                  </a-select>
                  <div v-if="isMandatoryField('location_city')">
                    <div v-if="$v.municity.$dirty" class="text-danger">
                      <div class="error" v-if="!$v.municity.required">
                        Field is required
                      </div>
                    </div>
                  </div>
                </div>
              </base-input>

              <div class="row">
                <div class="col">
                  <base-input
                    label="Barangay"
                    :required="isMandatoryField('location_barangay')"
                  >
                    <div v-if="viewMode">
                      <!-- <a-input
                        placeholder=""
                        v-model="location_barangay"
                        disabled
                      /> -->
                      <masked-input
                        v-model="location_barangay"
                        :viewMode="viewMode"
                        :disabled="viewMode"
                        @blur="checkDataDiff"
                        :maskFn="maskString"
                      />
                    </div>
                    <div v-else>
                      <a-select
                        id="location_barangay"
                        :disabled="viewMode"
                        v-model="formData.barangay_code"
                        @change="
                          () => {
                            onChangeBarangay();
                            checkDataDiff('location_barangay');
                          }
                        "
                        show-search
                        optionFilterProp="children"
                      >
                        <a-select-option
                          v-for="barangay in options.barangays"
                          :key="barangay.code"
                          :value="barangay.code"
                        >
                          {{ barangay.name }}
                        </a-select-option>
                      </a-select>
                      <div v-if="isMandatoryField('location_barangay')">
                        <div
                          v-if="
                            $v.formData.barangay_code.$dirty ||
                            $v.formData.location_barangay.$dirty
                          "
                          class="text-danger"
                        >
                          <div
                            class="error"
                            v-if="
                              !$v.formData.barangay_code.required ||
                              !$v.formData.location_barangay.required
                            "
                          >
                            Field is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </base-input>
                </div>
                <div class="col">
                  <base-input
                    label="Zip Code"
                    :required="isMandatoryField('zipcode')"
                  >
                    <div v-if="viewMode">
                      <a-input
                        placeholder=""
                        v-model="formData.zipcode"
                        disabled
                      />
                    </div>
                    <div v-else>
                      <!-- <a-input
                        id="zipcode"
                        class="w-100"
                        v-model="formData.zipcode"
                        :disabled="viewMode"
                      /> -->

                      <masked-input
                        id="zipcode"
                        class="w-100"
                        v-model="formData.zipcode"
                        :viewMode="viewMode"
                        :disabled="viewMode"
                        @blur="checkDataDiff"
                        :maskFn="maskString"
                      />
                      <div v-if="isZipcodeError">
                        <div class="text-danger">
                          <div class="error">Field only accepts number</div>
                        </div>
                      </div>
                      <div v-if="isMandatoryField('zipcode')">
                        <div
                          v-if="$v.formData.zipcode.$dirty"
                          class="text-danger"
                        >
                          <div
                            class="error"
                            v-if="!$v.formData.zipcode.required"
                          >
                            Field is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <base-input
                    label="Unit Number"
                    :required="isMandatoryField('location_unit')"
                  >
                    <div v-if="viewMode">
                      <!-- <a-input
                        placeholder=""
                        v-model="formData.location_unit"
                        disabled
                      /> -->

                      <masked-input
                        v-model="formData.location_unit"
                        :viewMode="viewMode"
                        :disabled="viewMode"
                        @blur="checkDataDiff"
                        :maskFn="maskString"
                      />
                    </div>
                    <div v-else>
                      <a-input
                        id="location_unit"
                        v-model="formData.location_unit"
                        :disabled="viewMode"
                        @blur="checkDataDiff"
                      />

                      <div v-if="isMandatoryField('location_unit')">
                        <div
                          v-if="$v.formData.location_unit.$dirty"
                          class="text-danger"
                        >
                          <div
                            class="error"
                            v-if="!$v.formData.location_unit.required"
                          >
                            Field is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </base-input>
                </div>
                <div class="col">
                  <base-input
                    label="Street"
                    :required="isMandatoryField('location_street')"
                  >
                    <div v-if="viewMode">
                      <!-- <a-input
                        placeholder=""
                        v-model="formData.location_street"
                        disabled
                      /> -->

                      <masked-input
                        v-model="formData.location_street"
                        :viewMode="viewMode"
                        :disabled="viewMode"
                        @blur="checkDataDiff"
                        :maskFn="maskString"
                      />
                    </div>
                    <div v-else>
                      <a-input
                        id="locatio_street"
                        v-model="formData.location_street"
                        :disabled="viewMode"
                        @blur="checkDataDiff"
                      />
                      <div v-if="isMandatoryField('location_street')">
                        <div
                          v-if="$v.formData.location_street.$dirty"
                          class="text-danger"
                        >
                          <div
                            class="error"
                            v-if="!$v.formData.location_street.required"
                          >
                            Field is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </base-input>
                </div>
              </div>
            </div>
            <!-- /Address Tab -->

            <!-- Contact Tab -->
            <div v-if="currentStep == 3">
              <!-- <base-input v-if="nullableMobileNumber">
                <a-switch
                  v-model="formData.allow_null_mobile_no"
                  :disabled="viewMode"
                />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label class="form-control-label"
                  >Allow Null Mobile Number</label
                >
              </base-input> -->
              <div v-if="requiredMobileNumber">
                <base-input
                  label="Mobile Number"
                  :required="requiredMobileNumber"
                >
                  <a-input-group compact>
                    <a-select
                      default-value="+63"
                      style="width: 15%"
                      v-model="countryCode"
                      :disabled="
                        viewMode ||
                        (memberData != null &&
                          this.memberData.is_registered_to_mobile_app == 1)
                      "
                    >
                      <a-select-option value="+63"> +63</a-select-option>
                    </a-select>

                    <!-- <a-input
                      id="mobile_no"
                      v-model="mobileNo"
                      style="width: 85%"
                      placeholder="10-digit mobile number"
                      :disabled="
                        viewMode ||
                        (memberData != null &&
                          this.memberData.is_registered_to_mobile_app == 1)
                      "
                      @blur="checkDataDiff"
                    /> -->

                    <masked-input
                      id="mobile_no"
                      style="width: 85%"
                      placeholder="10-digit mobile number"
                      v-model="mobileNo"
                      :viewMode="viewMode"
                      :disabled="
                        viewMode ||
                        (memberData != null &&
                          this.memberData.is_registered_to_mobile_app == 1)
                      "
                      @blur="checkDataDiff"
                      :maskFn="maskString"
                    />
                  </a-input-group>
                  <div v-if="$v.formData.mobile_no.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.mobile_no.required">
                      Field is required
                    </div>
                    <div
                      class="error"
                      v-else-if="!$v.formData.mobile_no.mobileNoFormat"
                    >
                      Invalid mobile number format. Use +639XXXXXXXXX format.
                    </div>
                  </div>
                </base-input>
              </div>

              <base-input label="Email" :required="isMandatoryField('email')">
                <!-- <a-input
                  id="email"
                  v-model="formData.email"
                  :disabled="viewMode"
                  @blur="checkDataDiff"
                /> -->

                <masked-input
                  id="email"
                  v-model="formData.email"
                  :viewMode="viewMode"
                  :disabled="viewMode"
                  @blur="checkDataDiff"
                  :maskFn="maskString"
                />

                <div
                  v-if="isMandatoryField('email') && $v.formData.email.$dirty"
                  class="text-danger"
                >
                  <div class="error" v-if="!$v.formData.email.email">
                    Invalid email format.
                  </div>
                </div>
              </base-input>
            </div>
            <!-- /Contact Tab -->

            <!-- Member Profile Tab -->
            <div v-if="currentStep == 0">
              <base-input label="Membership Program" required>
                <div v-if="viewMode">
                  <base-input
                    id="membership_program_id"
                    v-model="memberShipProgramName"
                    :viewMode="viewMode"
                    :disabled="viewMode"
                    @blur="checkDataDiff"
                    :maskFn="maskString"
                  />
                  <!-- <a-input
                    placeholder=""
                    v-model="memberShipProgramName"
                    disabled
                  /> -->
                </div>
                <div v-else>
                  <a-select
                    id="membership_program_id"
                    :disabled="viewMode || memberData != null"
                    v-model="formData.membership_program_id"
                    @change="
                      () => {
                        onChangeMembershipProgram();
                        checkDataDiff('membership_program_id');
                        setMandatoryFields();
                      }
                    "
                  >
                    <a-select-option
                      v-for="membershipProgram in options.membershipPrograms"
                      :key="membershipProgram.id"
                      :value="membershipProgram.id"
                    >
                      {{ membershipProgram.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div
                  v-if="$v.formData.membership_program_id.$dirty"
                  class="text-danger"
                >
                  <div
                    class="error"
                    v-if="!$v.formData.membership_program_id.required"
                  >
                    Field is required
                  </div>
                </div>
              </base-input>

              <base-input label="Membership Level" required>
                <br />
                <div v-if="viewMode">
                  <!-- <a-input placeholder="" v-model="memberLevelName" disabled /> -->

                  <base-input
                    v-model="memberLevelName"
                    :viewMode="viewMode"
                    :disabled="viewMode"
                    @blur="checkDataDiff"
                    :maskFn="maskString"
                  />
                </div>
                <div v-else>
                  <a-select
                    id="membership_level_id"
                    :disabled="
                      (!selectedActions.includes(
                        'Allow Update Membership Level'
                      ) &&
                        memberData !== null) ||
                      viewMode
                    "
                    v-model="formData.membership_level_id"
                    @change="checkDataDiff('membership_level_id')"
                  >
                    <a-select-option
                      v-for="membershipLevel in options.membershipLevels"
                      :key="membershipLevel.id"
                      :value="membershipLevel.id"
                    >
                      {{ membershipLevel.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div
                  v-if="$v.formData.membership_level_id.$dirty"
                  class="text-danger"
                >
                  <div
                    class="error"
                    v-if="!$v.formData.membership_level_id.required"
                  >
                    Field is required
                  </div>
                </div>
              </base-input>

              <base-input label="Member Status" required>
                <br />
                <div v-if="viewMode">
                  <!-- <a-input placeholder="" v-model="memberStatusName" disabled /> -->
                  <base-input
                    v-model="memberStatusName"
                    :viewMode="viewMode"
                    :disabled="viewMode"
                    @blur="checkDataDiff"
                    :maskFn="maskString"
                  />
                </div>
                <div v-else>
                  <a-select
                    id="member_status_id"
                    :disabled="viewMode"
                    v-model="formData.member_status_id"
                    @change="checkDataDiff('member_status_id')"
                    required
                  >
                    <a-select-option
                      v-for="memberStatus in options.memberStatuses"
                      :key="memberStatus.id"
                      :value="memberStatus.id"
                    >
                      {{ memberStatus.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div
                  v-if="$v.formData.member_status_id.$dirty"
                  class="text-danger"
                >
                  <div
                    class="error"
                    v-if="!$v.formData.member_status_id.required"
                  >
                    Field is required
                  </div>
                </div>
              </base-input>

              <!-- <base-input
                label="Customer Type"
                :required="isMandatoryField('customer_type')"
              >
                <br />
                <div v-if="viewMode">

                  <base-input
                    v-model="customerTypeName"
                    :viewMode="viewMode"
                    :disabled="viewMode"
                    @blur="checkDataDiff"
                    :maskFn="maskString"
                  />
                </div>
                <div v-else>
                  <a-select
                    id="customer_type_id"
                    :disabled="viewMode"
                    v-model="formData.customer_type_id"
                    @change="checkDataDiff('customer_type_id')"
                  >
                    <a-select-option
                      v-for="customerType in options.customerTypes"
                      :key="customerType.id"
                      :value="customerType.id"
                    >
                      {{ customerType.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div
                  v-if="
                    $v.formData.customer_type_id &&
                    $v.formData.customer_type_id.$dirty
                  "
                  class="text-danger"
                >
                  <div
                    class="error"
                    v-if="!$v.formData.customer_type_id.required"
                  >
                    Field is required
                  </div>
                </div>
              </base-input> -->

              <base-input label="Member Tags">
                <a-select
                  mode="multiple"
                  show-search
                  style="width: 100%"
                  v-model="memberTags"
                  :disabled="viewMode"
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="memberTag in options.memberTags"
                    :key="memberTag.id"
                    :value="memberTag.id"
                  >
                    {{ memberTag.name }}
                  </a-select-option>
                </a-select>
              </base-input>

              <div v-if="memberDataRegisteredSite">
                <a-list bordered>
                  <a-list-item>
                    <span v-if="viewMode">{{
                      typeof memberDataRegisteredSite.name !== 'undefined'
                        ? memberDataRegisteredSite.name
                        : null
                    }}</span>
                    <span v-else>
                      {{
                        typeof memberDataRegisteredSite.name !== 'undefined'
                          ? memberDataRegisteredSite.name
                          : null
                      }}</span
                    >
                  </a-list-item>
                  <div slot="header">
                    <b>Registration Site</b>
                  </div>
                </a-list>
                <hr />
              </div>

              <!-- <a-list
              bordered
              :data-source="registeredSitePages"
              v-if="memberData !== null && registeredSitePages"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <a href="#">{{ item.sub_domain }}</a>
              </a-list-item>
              <div slot="header">
                <b>Registered Site Pages</b>
              </div>
            </a-list>-->
            </div>
            <!-- /Member Profile Tab -->

            <!-- Marketing Subscription Tab  -->
            <div v-if="currentStep == 4">
              <br />
              <div class="row">
                <div class="col-12">
                  <a-checkbox
                    v-model="subscribeToMarketing"
                    :disabled="viewMode"
                  >
                    <span>Subscribe to Marketing</span>
                  </a-checkbox>
                </div>
              </div>
            </div>
            <!-- /Marketing Subscription Tab -->

            <!-- Account Specfic Fields -->
            <div v-if="dynamic_form.length > 0 && currentStep == 5">
              <!-- <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="customerCardType" @valueUpdated="updateSettings" :key="dynamicFormKey"/> -->
              <dynamic-form
                ref="dynamicForm"
                :convertedJson="{ mode: 'tabs', groups: dynamic_form }"
                :disabled="viewMode"
                :formSettings="memberDataMeta"
                @valueUpdated="updateSettings"
                :key="dynamicFormKey"
                :formData="formData"
                :membershipPrograms="options.membershipPrograms"
                :membershipLevels="options.membershipLevels"
              ></dynamic-form>
            </div>
            <!-- /Account Specfic Fields -->
          </div>
        </a-spin>
        <div
          style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          "
        >
          <div class="container mx-0 px-0">
            <div class="row">
              <div class="col-auto mr-auto">
                <b-button
                  size="sm"
                  class="float-md-left"
                  style="margin-left: 8px"
                  @click.prevent="closeDrawer()"
                >
                  Cancel
                </b-button>
              </div>

              <!-- <div class="col-auto mr-auto">
                <b-button
                  v-if="memberData !== null"
                  size="sm"
                  variant="warning"
                  class="float-md-left"
                  style="margin-left: 8px"
                  @click.prevent="secure()"
                  :disabled="canAccessSensitiveInfo"
                >
                  Fetch Sensitive Info
                </b-button>
              </div>-->
              <div v-if="dynamic_form.length == 0" class="col-auto">
                <template v-if="currentStep >= 1 && currentStep <= 4">
                  <b-button size="sm" @click="currentStep--">
                    Previous
                  </b-button>
                </template>

                <template v-if="currentStep >= 0 && currentStep <= 3">
                  <b-button
                    size="sm"
                    variant="primary"
                    @click="increaseCurrentStep()"
                  >
                    Next
                  </b-button>
                </template>

                <template v-if="currentStep == 4">
                  <b-button
                    v-if="memberData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createMemberProfile"
                    :disabled="formSubmitting"
                  >
                    <span v-if="!formSubmitting">Create</span>
                    <span v-else
                      ><a-spin :spinning="formSubmitting" /> Submitting
                      ...</span
                    >
                  </b-button>

                  <span v-else>
                    <b-button
                      v-if="dataIsChanged"
                      size="sm"
                      variant="primary"
                      @click.prevent="showUpdateModal"
                      :disabled="viewMode || formSubmitting"
                    >
                      <span v-if="!formSubmitting">Update</span>
                      <span v-else
                        ><a-spin :spinning="formSubmitting" /> Updating
                        ...</span
                      >
                    </b-button>
                    <b-button
                      v-else
                      size="sm"
                      variant="primary"
                      @click.prevent="confirmUpdate"
                      :disabled="viewMode || formSubmitting"
                    >
                      <span v-if="!formSubmitting">Update</span>
                      <span v-else
                        ><a-spin :spinning="formSubmitting" /> Updating
                        ...</span
                      >
                    </b-button>
                  </span>
                </template>
              </div>
              <div v-if="dynamic_form.length > 0" class="col-auto">
                <template v-if="currentStep >= 1 && currentStep <= 5">
                  <b-button size="sm" @click="currentStep--">
                    Previous
                  </b-button>
                </template>

                <template v-if="currentStep >= 0 && currentStep <= 4">
                  <b-button
                    size="sm"
                    variant="primary"
                    @click="increaseCurrentStep()"
                    :disabled="disableNext()"
                  >
                    Next
                  </b-button>
                </template>

                <template v-if="currentStep == 5">
                  <b-button
                    v-if="memberData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createMemberProfile"
                    :disabled="formSubmitting"
                  >
                    <span v-if="!formSubmitting">Create</span>
                    <span v-else
                      ><a-spin :spinning="formSubmitting" /> Submitting
                      ...</span
                    >
                  </b-button>

                  <span v-else>
                    <b-button
                      v-if="dataIsChanged"
                      size="sm"
                      variant="primary"
                      @click.prevent="showUpdateModal"
                      :disabled="viewMode || formSubmitting"
                    >
                      <span v-if="!formSubmitting">Update</span>
                      <span v-else
                        ><a-spin :spinning="formSubmitting" /> Updating
                        ...</span
                      >
                    </b-button>
                    <b-button
                      v-else
                      size="sm"
                      variant="primary"
                      @click.prevent="confirmUpdate"
                      :disabled="viewMode || formSubmitting"
                    >
                      <span v-if="!formSubmitting">Update</span>
                      <span v-else
                        ><a-spin :spinning="formSubmitting" /> Updating
                        ...</span
                      >
                    </b-button>
                  </span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Quick Registration Form -->
      <div v-else>
        <a-spin tip="Please wait ..." :spinning="formLoading">
          <base-input label="Membership Program" required>
            <br />
            <a-select
              v-model="formData.membership_program_id"
              @change="
                () => {
                  onChangeMembershipProgram();
                }
              "
              :disabled="viewMode || memberData != null"
            >
              <a-select-option
                v-for="membershipProgram in options.membershipPrograms"
                :key="membershipProgram.id"
                :value="membershipProgram.id"
              >
                {{ membershipProgram.name }}
              </a-select-option>
            </a-select>
            <div
              v-if="$v.formData.membership_program_id.$dirty"
              class="text-danger"
            >
              <div
                class="error"
                v-if="!$v.formData.membership_program_id.required"
              >
                Field is required
              </div>
            </div>
          </base-input>

          <base-input label="Membership Level" required>
            <br />
            <a-select
              v-model="formData.membership_level_id"
              :disabled="
                !selectedActions.includes('Allow Update Membership Level') &&
                memberData !== null
              "
            >
              <a-select-option
                v-for="membershipLevel in options.membershipLevels"
                :key="membershipLevel.id"
                :value="membershipLevel.id"
              >
                {{ membershipLevel.name }}
              </a-select-option>
            </a-select>
            <div
              v-if="$v.formData.membership_level_id.$dirty"
              class="text-danger"
            >
              <div
                class="error"
                v-if="!$v.formData.membership_level_id.required"
              >
                Field is required
              </div>
            </div>
          </base-input>

          <base-input label="First Name" required>
            <a-input v-model.trim="$v.formData.first_name.$model" />
            <div v-if="$v.formData.first_name.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.first_name.required">
                Field is required
              </div>
            </div>
          </base-input>

          <base-input label="Last Name" required>
            <a-input v-model.trim="$v.formData.last_name.$model" />
            <div v-if="$v.formData.last_name.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.last_name.required">
                Field is required
              </div>
            </div>
          </base-input>

          <!-- <base-input v-if="nullableMobileNumber">
            <b-form-checkbox
              v-model="formData.allow_null_mobile_no"
              name="check-button"
              switch
              :disabled="viewMode"
              @change="(e) => displayAuthActivityModal(e)"
            >
              <label class="form-control-label">Allow Null Mobile Number</label>
            </b-form-checkbox>
          </base-input> -->
          <div v-if="requiredMobileNumber">
            <base-input label="Mobile Number" :required="nullableMobileNumber">
              <!-- <a-input v-model.trim="$v.formData.mobile_no.$model" /> -->
              <a-input-group compact>
                <a-select
                  default-value="+63"
                  style="width: 15%"
                  v-model="countryCode"
                >
                  <a-select-option value="+63"> +63</a-select-option>
                </a-select>

                <masked-input
                  v-model="mobileNo"
                  :viewMode="viewMode"
                  :disabled="viewMode"
                  @blur="checkDataDiff"
                  :maskFn="maskString"
                  style="width: 85%"
                  placeholder="10-digit mobile number"
                />
                <!-- <a-input
                  v-model="mobileNo"
                  style="width: 85%"
                  placeholder="10-digit mobile number"
                /> -->
              </a-input-group>
              <!-- here code -->
              <div v-if="requiredMobileNumber">
                <div v-if="$v.formData.mobile_no.$dirty" class="text-danger">
                  <div class="error" v-if="!$v.formData.mobile_no.required">
                    Field is required
                  </div>
                  <div
                    class="error"
                    v-else-if="!$v.formData.mobile_no.mobileNoFormat"
                  >
                    Invalid mobile number format. Use +639XXXXXXXXX format.
                  </div>
                </div>
              </div>
            </base-input>
          </div>

          <base-input label="Member Status" required>
            <a-select v-model="formData.member_status_id" required>
              <a-select-option
                v-for="memberStatus in options.memberStatuses"
                :key="memberStatus.id"
                :value="memberStatus.id"
              >
                {{
                  viewMode ? maskString(memberStatus.name) : memberStatus.name
                }}
              </a-select-option>
            </a-select>
            <div v-if="$v.formData.member_status_id.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.member_status_id.required">
                Field is required
              </div>
            </div>
          </base-input>
        </a-spin>

        <div
          style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          "
        >
          <div class="container mx-0 px-0">
            <div class="row">
              <div class="col-auto mr-auto">
                <b-button
                  size="sm"
                  class="float-md-left"
                  style="margin-left: 8px"
                  @click.prevent="closeDrawer()"
                >
                  Cancel
                </b-button>
              </div>

              <div class="col-auto">
                <template>
                  <b-button
                    size="sm"
                    variant="primary"
                    @click.prevent="createMemberProfile"
                    :disabled="formSubmitting"
                  >
                    <span v-if="!formSubmitting">Create</span>
                    <span v-else
                      ><a-spin :spinning="formSubmitting" /> Submitting
                      ...</span
                    >
                  </b-button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /quick registration form -->
    </form>

    <a-modal
      v-model="assignModal.visible"
      title="Assign Card"
      ok-text="Yes"
      cancel-text="No"
      @cancel="closeDrawer"
      @ok="handleOkForAssignCard"
    >
      <div class="d-flex justify-content-center">
        <h4>Do you want to assign card to member?</h4>
      </div>
    </a-modal>
    <a-modal
      v-model="updateModal.visible"
      title="Confirmation"
      ok-text="Update"
      cancel-text="Close"
      @ok="
        () => {
          editMemberProfile();
          updateModal.visible = false;
          updateReason = null;
        }
      "
    >
      <p>Please state the reason for updating the data</p>

      <a-input v-model="updateReason" />
    </a-modal>

    <b-modal id="modalDpc" title="Data Privacy Policy" ok-only size="lg">
      <!-- <PdfViewer :pdfUrl="dataPrivacyFilePath"/> -->
      <iframe
        type="application/pdf"
        :src="dataPrivacyFilePath + '#toolbar=0&view=FitH'"
        width="100%"
        height="500vh"
      ></iframe>
    </b-modal>

    <authorize-activity
      url="/api/auth/users/auth-activity"
      :memberShipProgramId="formData.membership_program_id"
      :authActivityModal="authActivityModal"
      v-on:closeModal="closeAuthActivityModal($event)"
    />

    <!-- <a-drawer
      :width="480"
      placement="right"
      :visible="cardAssignmentDrawer.visible"
      @close="closeCardAssignmentDrawer"
      :closable="!isSuper8"
      :maskClosable="!isSuper8"
      :keyboard="!isSuper8"
    >
      <CardAssignmentFormCS
        v-if="hasCardSellingModule"
        :memberData="formData"
        @closeDrawer="closeCardAssignmentDrawer"
      />
      <CardAssignmentForm
        v-else
        :memberData="formData"
        :fromForm="true"
        @closeDrawer="closeCardAssignmentDrawer"
      />
    </a-drawer> -->
  </div>
</template>

<script>
import PSCGApi from '../../controllers/psgcApi';
import HTTPRequest from '../../controllers/httpRequest';
import DynamicForm from '../DynamicForm.vue';
import moment from 'moment';
import { required, email } from 'vuelidate/lib/validators';
// import PdfViewer from '@/components/PdfViewer.vue';
import AuthorizeActivity from '@/components/Custom/AuthorizeActivity';
// import CardAssignmentForm from '../CardManagement/CardAssignmentForm.vue';
// import CardAssignmentFormCS from '../CardManagement/CardTransaction/CardAssignmentFormCS.vue';
import { mapGetters } from 'vuex';
import secureStorage from '@/controllers/secureStorage';

import { maskString } from '../../helpers/stringHelper.js';

import MaskedInput from '@/components/Custom/MaskedInput';

const NCR_REGION_CODE = 130000000;

export default {
  name: 'MemberProfileForm',
  props: {
    memberData: Object,
    viewMode: Boolean,
    quickRegistration: {
      type: Boolean,
      default: false
    },
    drawerVisible: Boolean,
    currentSiteId: {
      type: Number,
      default: null
    },
    dataPrivacyFilePath: {
      type: String,
      default: null
    }
  },
  components: {
    // CardAssignmentForm,
    // PdfViewer,
    // CardAssignmentFormCS,
    MaskedInput,
    DynamicForm,
    AuthorizeActivity
  },
  data() {
    return {
      hasCardSellingModule: false,
      memberShipProgramName: '',
      memberLevelName: '',
      memberStatusName: '',
      customerTypeName: '',
      location_barangay: '',
      location_city: '',
      location_country: '',
      location_province: '',
      location_region: '',
      formLoading: false,
      enableAssignCard: false,
      requiredMobileNumber: true,
      authActivityModal: false,
      mandatoryFields: null,
      memberDataMeta: {},
      memberDataRegisteredSite: {},
      dynamicFormKey: 0,
      dynamic_form: [],
      defaultMembershipProgram: null,
      currentStep: 0,
      birthMonth: null,
      disableBirthMonth: false,
      disableBirthYear: false,
      disableBirthDay: false,
      birthDay: null,
      birthYear: null,
      mobileNo: null,
      countryCode: '+63',
      yearStart: moment().year() - 101,
      dataIsChanged: false,
      updateReason: null,
      hasCustomFieldError: false,
      cardAssignmentDrawer: {
        visible: false
      },
      assignModal: {
        visible: false
      },
      userCreated: false,
      updateModal: {
        visible: false
      },
      memberTags: [],
      municity: null,
      isZipcodeError: false,
      formData: {
        id: null,
        membership_program_id: null,
        membership_level_id: null,
        first_name: null,
        middle_name: null,
        last_name: null,
        last_name_suffix: null,
        nick_name: null,
        mobile_no: null,
        allow_null_mobile_no: false,
        allow_null_mobile_no_user_id: null,
        email: null,
        zipcode: null,
        location_unit: null,
        location_street: null,
        location_barangay: null,
        barangay_code: null,
        location_city: null,
        city_code: null,
        location_municipality: null,
        municipality_code: null,
        location_province: null,
        province_code: null,
        location_region: null,
        region_code: null,
        location_country: 'PH',
        gender: null,
        birth_month: null,
        birth_year: null,
        birth_day: null,
        customer_type_id: null,
        member_status_id: null,
        member_tags: null,
        marketing_subscription_flag: false
      },
      options: {
        membershipPrograms: [],
        membershipLevels: [],
        memberStatuses: [],
        customerTypes: [],
        memberTags: [],
        barangays: [],
        cities: [],
        provinces: [],
        regions: [],
        genders: [
          { key: 'M', name: 'Male' },
          { key: 'F', name: 'Female' }
        ],
        months: [
          { key: '01', name: 'January' },
          { key: '02', name: 'February' },
          { key: '03', name: 'March ' },
          { key: '04', name: 'April ' },
          { key: '05', name: 'May ' },
          { key: '06', name: 'June' },
          { key: '07', name: 'July ' },
          { key: '08', name: 'August ' },
          { key: '09', name: 'September' },
          { key: '10', name: 'October' },
          { key: '11', name: 'November' },
          { key: '12', name: 'December' }
        ]
      },
      formSubmitting: false,
      isRegionNCR: false,
      registeredSitePages: [],
      customerSensitiveInfo: null,
      canAccessSensitiveInfo: false
    };
  },

  validations() {
    var validation = {
      formData: {
        membership_program_id: { required },
        membership_level_id: { required },
        member_status_id: { required },
        first_name: { required },
        last_name: { required }
      }
    };

    if (this.requiredMobileNumber == true) {
      validation.formData['mobile_no'] = {
        required,
        mobileNoFormat(value) {
          const regex = /^(\+639)\d{9}$/;
          return regex.test(value);
        }
      };
    } else if (this.formData.mobile_no != null) {
      validation.formData['mobile_no'] = {
        mobileNoFormat(value) {
          const regex = /^(\+639)\d{9}$/;
          return regex.test(value);
        }
      };
    }

    if (this.mandatoryFields != null && !this.quickRegistration) {
      if (this.mandatoryFields?.customer_type == true) {
        validation.formData['customer_type_id'] = { required };
      }
      if (this.mandatoryFields.email == true) {
        validation.formData['email'] = { required, email };
      }

      if (this.mandatoryFields.gender) {
        validation.formData['gender'] = { required };
      }

      if (this.mandatoryFields.location_city) {
        validation['municity'] = { required };
      }

      if (this.mandatoryFields.location_region) {
        validation.formData['region_code'] = { required };
        validation.formData['location_region'] = { required };
      }
      if (this.mandatoryFields.location_barangay) {
        validation.formData['barangay_code'] = { required };
        validation.formData['location_barangay'] = { required };
      }
      if (this.mandatoryFields.location_street) {
        validation.formData['location_street'] = { required };
      }
      if (this.mandatoryFields.location_unit) {
        validation.formData['location_unit'] = { required };
      }
      if (this.mandatoryFields.location_unit) {
        validation.formData['location_unit'] = { required };
      }
      if (this.mandatoryFields.location_province) {
        validation.formData['province_code'] = { required };
        validation.formData['location_province'] = { required };
      }
      if (this.mandatoryFields.zipcode) {
        validation['zipcode'] = {
          required,
          numeric: (value) => /^\d+$/.test(value)
        };
      }
      if (this.mandatoryFields.birth_month) {
        validation['birthMonth'] = { required };
      }

      if (this.mandatoryFields.birth_day) {
        validation['birthDay'] = { required };
      }

      if (this.mandatoryFields.birth_year) {
        validation['birthYear'] = { required };
      }
    }

    return validation;
  },
  methods: {
    moment,
    maskString,
    validateBirthday() {
      const bday = parseInt(this.birthDay);
      if (bday != null && bday > this.bdayValidDays) {
        this.formData.birth_day = null;
        this.birthDay = null;
      }
    },
    // async getCardSellingFeature() {
    //   const response = await HTTPRequest.getRequest(
    //     `/api/v1/clp_accounts/settings/CARD_SELLING_FEATURE`
    //   );

    //   if (response.account_id) {
    //     this.hasCardSellingModule = response.value == 'true';
    //   }
    // },
    async increaseCurrentStep() {
      var continueStep = true;
      if (!this.viewMode) {
        if (this.currentStep == 0) {
          if (this.$v.formData.customer_type_id) {
            this.$v.formData.customer_type_id.$touch();
            if (this.$v.formData.customer_type_id?.$invalid) {
              continueStep = false;
            }
          }
        }
        if (this.currentStep == 1) {
          this.$v.formData.first_name.$touch();
          this.$v.formData.last_name.$touch();
          if (
            this.$v.formData.first_name.$invalid ||
            this.$v.formData.last_name.$invalid
          ) {
            continueStep = false;
          }

          if (this.isMandatoryField('gender')) {
            this.$v.formData.gender.$touch();
            if (this.$v.formData.gender.$invalid) {
              continueStep = false;
            }
          }

          if (this.isMandatoryField('birth_month')) {
            this.$v.birthMonth.$touch();
            if (this.$v.birthMonth.$invalid) {
              continueStep = false;
            }
          }
          if (this.isMandatoryField('birth_day')) {
            this.$v.birthDay.$touch();
            if (this.$v.birthDay.$invalid) {
              continueStep = false;
            }
          }
          if (this.isMandatoryField('birth_year')) {
            this.$v.birthYear.$touch();
            if (this.$v.birthYear.$invalid) {
              continueStep = false;
            }
          }

          if (this.memberData == null && continueStep) {
            // Indicates that this is newly created member process
            // Validate duplicate member
            this.validateDuplicate(continueStep);
            continueStep = false; // Set to false to prevent from jumping to next tab
          }

          if (!this.quickRegistration && !this.viewMode) {
            await this.getRegions();
            await this.initProvinces();
          }
          if (this.memberData && continueStep) {
            this.formLoading = true;
            if (this.memberData.region_code == NCR_REGION_CODE) {
              await this.getNcrCities(this.memberData.region_code);
            } else {
              await this.getProvinces(this.memberData.region_code);
            }

            await this.getCities(this.memberData.province_code);
            if (this.memberData.city_code != null) {
              await this.getBarangays(this.memberData.city_code);
            } else {
              await this.getBarangays(this.memberData.municipality_code);
            }
            this.formLoading = false;
          }
        } else if (this.currentStep == 2) {
          if (this.isMandatoryField('location_region')) {
            this.$v.formData.region_code.$touch();
            this.$v.formData.location_region.$touch();
            if (
              this.$v.formData.region_code.$invalid ||
              this.$v.formData.location_region.$invalid
            ) {
              continueStep = false;
            }
          }
          if (this.isMandatoryField('location_city')) {
            this.$v.municity.$touch();
            if (this.$v.municity.$invalid) {
              continueStep = false;
            }
          }
          console.log(
            "this.isMandatoryField('zipcode') ",
            this.isMandatoryField('zipcode')
          );
          if (this.isMandatoryField('zipcode')) {
            console.log('zip code is mandatory');
            this.$v.zipcode.$touch();
            console.log('this.$v.zipcode.$invalid ', this.$v.zipcode.$invalid);
            if (this.$v.zipcode.$invalid) {
              continueStep = false;
            }
          }

          if (this.isZipcodeError) {
            continueStep = false;
          }
          if (this.isMandatoryField('location_barangay')) {
            this.$v.formData.barangay_code.$touch();
            this.$v.formData.location_barangay.$touch();
            if (
              this.$v.formData.barangay_code.$invalid ||
              this.$v.formData.location_barangay.$invalid
            ) {
              continueStep = false;
            }
          }
          if (this.isMandatoryField('location_street')) {
            this.$v.formData.location_street.$touch();
            if (this.$v.formData.location_street.$invalid) {
              continueStep = false;
            }
          }
          if (this.isMandatoryField('location_unit')) {
            this.$v.formData.location_unit.$touch();
            if (this.$v.formData.location_unit.$invalid) {
              continueStep = false;
            }
          }
          if (this.isMandatoryField('zipcode')) {
            this.$v.formData.zipcode.$touch();
            if (this.$v.formData.zipcode.$invalid) {
              continueStep = false;
            }
          }
          if (
            this.isMandatoryField('location_province') &&
            this.$v.formData.province_code &&
            this.$v.formData.location_province
          ) {
            this.$v.formData.province_code.$touch();
            this.$v.formData.location_province.$touch();
            if (
              this.$v.formData.province_code.$invalid ||
              this.$v.formData.location_province.$invalid
            ) {
              continueStep = false;
            }
          }
        } else if (this.currentStep == 3) {
          if (
            this.isMandatoryField('mobile_no') &&
            !this.formData.allow_null_mobile_no
          ) {
            this.$v.formData.mobile_no.$touch();
            if (this.$v.formData.mobile_no.$invalid) {
              continueStep = false;
            }
          }
          if (this.isMandatoryField('email')) {
            this.$v.formData.email.$touch();
            if (this.$v.formData.email.$invalid) {
              continueStep = false;
            }
          }
        } else if (this.currentStep == 4) {
          this.$v.formData.marketing_subscription_flag.$touch();
          if (this.$v.formData.marketing_subscription_flag.$invalid) {
            continueStep = false;
          }
        }
      }
      if (continueStep) {
        this.currentStep++;
      }
    },
    decreaseCurrentStep() {
      this.currentStep--;
    },
    async validateDuplicate(currentContinueStep = false) {
      this.formLoading = true;
      const _self = this;
      const response = await HTTPRequest.postRequest(
        '/api/v1/clp_members/validate_duplicate',
        {
          member: this.formData
        }
      );

      if (response != null && response.id) {
        await this.$confirm({
          title: 'Do you want to continue?',
          content:
            'Duplicate member details found based on name and birthday. Do you want to continue creating a new member profile?',
          okText: 'Yes',
          cancelText: 'No',
          onOk() {
            _self.currentStep++;
          },
          onCancel() {}
        });
      } else {
        if (currentContinueStep) _self.currentStep++;
      }

      this.formLoading = false;
    },
    closeAuthActivityModal(object) {
      const { status, userId } = object;
      if (status == true) {
        this.formData.allow_null_mobile_no = true;
        this.requiredMobileNumber = false;
        this.formData.allow_null_mobile_no_user_id = userId;
        this.formData.mobile_no = null;
      } else {
        this.formData.allow_null_mobile_no = false;
        this.requiredMobileNumber = true;
      }
      this.authActivityModal = false;
    },
    displayAuthActivityModal(e) {
      if (e == true) {
        this.authActivityModal = true;
        this.formData.mobile_no = null;
        this.formData.allow_null_mobile_no = true;
        this.formData.mobile_no = null;
      } else {
        this.requiredMobileNumber = true;
        this.formData.allow_null_mobile_no = false;
        this.formData.allow_null_mobile_no_user_id = null;
      }
    },
    isMandatoryField(val) {
      if (!this.viewMode) {
        if (this.mandatoryFields[val] != undefined) {
          return this.mandatoryFields[val];
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    setMandatoryFields() {
      if (this.formData.membership_program_id != null) {
        this.getMembershipProgramDetails(this.formData.membership_program_id);
      }
    },
    closeCardAssignmentDrawer() {
      this.closeDrawer();
      this.$root.$emit('refreshTable');
      this.$notification.success({
        message: 'Data has been created.'
      });
      this.cardAssignmentDrawer.visible = false;
      this.memberData = null;
    },
    getMembershipProgramDetails(id) {
      if (this.options.membershipPrograms.length > 0) {
        this.options.membershipPrograms.forEach((program) => {
          if (program.id == id) {
            let default_status_id = program.default_member_status_id;
            if (this.quickRegistration) {
              default_status_id = program.default_quick_member_status_id;
            }
            this.formData.member_status_id = default_status_id;
            this.enableAssignCard =
              program.membership_card_generation_flag == 1;
            this.mandatoryFields = JSON.parse(
              program.mandatory_customer_fields
            );
          }
        });
      } else {
        console.log('Membership Program Options is Empty.');
      }
    },
    disableNext() {
      if (
        this.formData.membership_program_id == null ||
        this.formData.membership_level_id == null ||
        this.formData.member_status_id == null
      ) {
        return true;
      } else {
        return false;
      }
    },
    updateSettings(newFormSettings, settingsGrouping, errors) {
      console.log(newFormSettings);
      this.formData.meta = newFormSettings;
      console.log(settingsGrouping);
      console.log(errors);

      if (errors.length > 0) {
        this.hasCustomFieldError = true;
      } else {
        this.hasCustomFieldError = false;
      }
    },

    showUpdateModal() {
      this.updateModal.visible = true;
    },
    handleOkForAssignCard() {
      this.cardAssignmentDrawer.visible = true;
      this.assignModal.visible = false;
    },
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.defaultMembershipProgram = response.data[0];
      this.options.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async getMembershipLevels(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/membership_levels`
      );
      this.options.membershipLevels = data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async getMemberStatuses(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/member_statuses`
      );
      this.options.memberStatuses = data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async getMemberTags(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/member_tags`
      );
      this.options.memberTags = data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async getRegisteredSitePages(memberId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_members/${memberId}/registered_site_pages`
      );

      this.registeredSitePages = data;
    },

    async getRegions() {
      let data = await PSCGApi.get('/regions');
      this.options.regions = data.sort((a, b) => a.name.localeCompare(b.name));
    },

    async initProvinces() {
      const provinces = await PSCGApi.get('/provinces');
      this.options.provinces = provinces.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async getNcrCities(regionCode) {
      if (regionCode !== null) {
        this.options.cities = await PSCGApi.get(
          '/regions/' + regionCode + '/cities'
        );
      }
    },

    async getProvinces(regionCode) {
      if (regionCode !== null) {
        this.options.provinces = await PSCGApi.get(
          '/regions/' + regionCode + '/provinces'
        );
      }
    },

    async getCities(provinceCode) {
      if (provinceCode !== null) {
        this.options.cities = await PSCGApi.get(
          '/provinces/' + provinceCode + '/cities-municipalities/'
        );
      }
    },

    async getBarangays(cityCode) {
      if (cityCode !== null) {
        this.options.barangays = await PSCGApi.get(
          '/cities-municipalities/' + cityCode + '/barangays'
        );
      }
    },

    onChangeRegion() {
      this.formData.location_region = event.target.innerText;
      this.formData.province_code = null;
      this.formData.location_province = null;
      this.options.provinces = [];
      this.formData.city_code = null;
      this.formData.location_city = null;
      this.formData.municipality_code = null;
      this.formData.location_municipality = null;
      this.municity = null;
      this.options.cities = [];
      this.formData.barangay_code = null;
      this.formData.location_barangay = null;
      this.options.barangays = [];

      if (this.formData.region_code == NCR_REGION_CODE) {
        this.getNcrCities(this.formData.region_code);
        this.isRegionNCR = true;
        this.mandatoryFields.location_province = false;
      } else {
        this.getProvinces(this.formData.region_code);
        this.isRegionNCR = false;
        if (this.mandatoryFields['location_province'] != undefined) {
          this.mandatoryFields.location_province = true;
        }
      }
    },

    onChangeProvince() {
      if (this.formData.region_code == null) {
        this.formData.region_code = event.target.dataset.region_code;
      }
      this.formData.location_province = event.target.innerText;
      this.formData.city_code = null;
      this.formData.location_city = null;
      this.formData.municipality_code = null;
      this.formData.location_municipality = null;
      this.municity = null;
      this.options.cities = [];
      this.formData.barangay_code = null;
      this.formData.location_barangay = null;
      this.options.barangays = [];
      this.getCities(this.formData.province_code);
    },

    onChangeCity() {
      const isCity = event.target.dataset.city;
      let municity = 'city';
      if (isCity == true) {
        this.formData.location_city = event.target.innerText;
        this.formData.city_code = this.municity;
      } else {
        this.formData.location_municipality = event.target.innerText;
        this.formData.municipality_code = this.municity;
        municity = 'municipality';
      }
      this.formData.barangay_code = null;
      this.formData.location_barangay = null;
      this.options.barangays = [];
      this.getBarangays(this.municity);
      this.checkDataDiff(`location_${municity}`);
    },

    onChangeBarangay() {
      this.formData.location_barangay = event.target.innerText;
    },

    onChangeMembershipProgram() {
      this.formData.membership_level_id = null;
      this.formData.member_status_id = null;
      this.formData.customer_type_id = null;
      this.formData.member_tags = [];
      this.memberTags = [];
      this.options.memberTags = [];
      this.getMembershipLevels(this.formData.membership_program_id);
      this.getMemberStatuses(this.formData.membership_program_id);
      this.getMemberTags(this.formData.membership_program_id);
      this.setMandatoryFields();
    },

    async createMemberProfile() {
      let nonFormDataValidation = 0;
      if (this.mandatoryFields != null) {
        if (this.mandatoryFields.birth_month && !this.quickRegistration) {
          this.$v.birthMonth.$touch();
          if (this.$v.birthMonth.$invalid == true) {
            nonFormDataValidation++;
          }
        }
        if (this.mandatoryFields.birth_day && !this.quickRegistration) {
          this.$v.birthDay.$touch();
          if (this.$v.birthDay.$invalid == true) {
            nonFormDataValidation++;
          }
        }
        if (this.mandatoryFields.birth_year && !this.quickRegistration) {
          this.$v.birthYear.$touch();
          if (this.$v.birthYear.$invalid == true) {
            nonFormDataValidation++;
          }
        }
        if (this.mandatoryFields.location_city && !this.quickRegistration) {
          this.$v.municity.$touch();
          if (this.$v.municity.$invalid == true) {
            nonFormDataValidation++;
          }
        }
      }

      if (!this.quickRegistration && this.hasCustomFieldError) {
        return;
      }
      if (
        !this.quickRegistration &&
        this.$refs?.dynamicForm?.errors?.length > 0
      ) {
        return;
      }

      this.$v.formData.$touch();
      if (!this.$v.formData.$invalid && nonFormDataValidation == 0) {
        this.formSubmitting = true;
        let path =
          '/api/v1/clp_members?origin_site_id=' +
          secureStorage.getItem('currentSiteId');
        if (this.quickRegistration) {
          path = path + '&quickRegistration=true';
        }

        const response = await HTTPRequest.postRequest(path, {
          member: this.formData
        });

        if (response?.data?.id) {
          // if (this.enableAssignCard) {
          //   this.formData.id = response.data.id;
          //   if (this.isSuper8) {
          //     this.cardAssignmentDrawer.visible = true;
          //     this.userCreated = true;
          //   } else {
          //     this.assignModal.visible = true;
          //     this.userCreated = true;
          //   }
          // } else {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been created.'
          });
          // }
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },

    async editMemberProfile() {
      this.$v.formData.$touch();

      if (this.hasCustomFieldError) {
        return;
      }
      if (
        this.dynamic_form.length &&
        this.$refs.dynamicForm.errors.length > 0
      ) {
        return;
      }

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        if (
          this.mandatoryFields &&
          this.mandatoryFields.allow_null_mobile_no != undefined
        ) {
          if (this.formData.allow_null_mobile_no == undefined) {
            this.formData.allow_null_mobile_no = false;
          }
          if (this.formData.allow_null_mobile_no && this.formData.mobile_no) {
            this.formData.mobile_no = null;
          }
        } else {
          this.formData.allow_null_mobile_no = false;
        }
        let params = {
          member: this.formData
        };

        if (this.dataIsChanged) {
          params.update_reason = this.updateReason;
        }
        params.member.email =
          params.member && params.member.email
            ? params.member.email.replace(/^\s+|\s+$/gm, '')
            : null;
        if (params.member.email == '') {
          params.member.email = null;
        }

        const response = await HTTPRequest.putRequest(
          '/api/v1/clp_members/' + this.memberData.id,
          params
        );

        if (response?.data?.id) {
          this.formData.id = response.data.id;
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },

    async populateDefaultFields() {
      const defaultMembershipProgram = this.defaultMembershipProgram;
      this.formData.membership_program_id = defaultMembershipProgram.id;

      await this.getMembershipLevels(defaultMembershipProgram.id);
      this.formData.membership_level_id =
        defaultMembershipProgram.default_membership_level_id;

      await this.getMemberStatuses(defaultMembershipProgram.id);
      await this.getMemberTags(defaultMembershipProgram.id);
      this.setMandatoryFields();
    },

    confirmUpdate() {
      this.$confirm({
        title: 'Confirm',
        content: 'Are you sure you want to commit the changes you made?',
        onOk: () => {
          this.editMemberProfile();
        }
      });
    },

    closeDrawer() {
      if (this.userCreated) {
        this.$notification.success({
          message: 'Data has been created.'
        });
      }
      this.clearForm();
      this.resetFormOptions();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
      this.currentStep = 0;
      this.canAccessSensitiveInfo = false;
      this.hasCustomFieldError = false;
    },

    resetFormOptions() {
      this.options = {
        membershipPrograms: [],
        membershipLevels: [],
        memberStatuses: [],
        memberTags: [],
        barangays: [],
        cities: [],
        provinces: [],
        regions: [],
        genders: [
          { key: 'M', name: 'Male' },
          { key: 'F', name: 'Female' }
        ],
        months: [
          { key: '01', name: 'January' },
          { key: '02', name: 'February' },
          { key: '03', name: 'March ' },
          { key: '04', name: 'April ' },
          { key: '05', name: 'May ' },
          { key: '06', name: 'June' },
          { key: '07', name: 'July ' },
          { key: '08', name: 'August ' },
          { key: '09', name: 'September' },
          { key: '10', name: 'October' },
          { key: '11', name: 'November' },
          { key: '12', name: 'December' }
        ]
      };
    },

    clearForm() {
      this.formData = {
        membership_program_id: null,
        membership_level_id: null,
        first_name: null,
        middle_name: null,
        last_name: null,
        last_name_suffix: null,
        nick_name: null,
        mobile_no: null,
        allow_null_mobile_no: false,
        allow_null_mobile_no_user_id: null,
        email: null,
        zipcode: null,
        location_unit: null,
        location_street: null,
        location_barangay: null,
        barangay_code: null,
        location_city: null,
        city_code: null,
        location_province: null,
        province_code: null,
        location_region: null,
        region_code: null,
        location_country: 'PH',
        gender: null,
        birth_month: null,
        birth_year: null,
        birth_day: null,
        member_tags: null,
        member_status_id: null,
        customer_type_id: null,
        marketing_subscription_flag: false,
        meta: null
      };
      this.userCreated = false;
      // this.memberDataMeta = {};
      this.memberTags = [];
      this.birthMonth = null;
      this.birthDay = null;
      this.birthYear = null;
      this.mobileNo = null;
      this.hasCustomFieldError = false;
    },

    async setFormData(data = null) {
      if (data !== null) {
        if (this.viewMode) {
          this.memberShipProgramName = data?.membershipProgram?.name;
          this.memberLevelName = data?.membershipLevel?.name;
          this.memberStatusName = data?.memberStatus?.name;
          this.customerTypeName = data?.customerType?.name;
          this.location_barangay = data?.location_barangay;
          this.location_city =
            data?.location_city ?? data?.location_municipality;
          this.location_country = data?.location_country;
          this.location_province = data?.location_province;
          this.location_region = data?.location_region;
          await this.getMembershipLevels(data.membership_program_id);
        } else {
          await this.getMembershipLevels(data.membership_program_id);
          await this.getMemberStatuses(data.membership_program_id);
          await this.getRegisteredSitePages(data.id);
        }
        await this.getMemberTags(data.membership_program_id);

        const {
          membership_program_id,
          membership_level_id,
          first_name,
          middle_name,
          last_name,
          last_name_suffix,
          nick_name,
          mobile_no,
          email,
          location_unit,
          location_street,
          location_barangay,
          barangay_code,
          location_city,
          city_code,
          location_municipality,
          municipality_code,
          location_province,
          province_code,
          location_region,
          region_code,
          location_country,
          gender,
          member_tags,
          member_status_id,
          customer_type_id,
          marketing_subscription_flag,
          meta,
          zipcode
        } = data;

        let birth_month =
          data.birth_month != null
            ? moment(data.birth_month).format('YYYY-MM-DD')
            : null;
        let birth_year =
          data.birth_year != null
            ? moment(data.birth_year).format('YYYY-MM-DD')
            : null;
        let birth_day =
          data.birth_day != null
            ? moment(data.birth_day).format('YYYY-MM-DD')
            : null;

        if (city_code) {
          this.municity = city_code;
        } else {
          this.municity = municipality_code;
        }
        this.formData = {
          membership_program_id,
          membership_level_id,
          first_name,
          middle_name,
          last_name,
          last_name_suffix,
          nick_name,
          mobile_no,
          email,
          location_unit,
          location_street,
          location_barangay,
          barangay_code,
          location_city,
          city_code,
          location_municipality,
          municipality_code,
          location_province,
          province_code,
          location_region,
          region_code,
          location_country,
          gender,
          birth_month,
          birth_year,
          birth_day,
          member_tags,
          member_status_id,
          customer_type_id,
          marketing_subscription_flag,
          meta,
          zipcode
        };

        if (this.isJsonString(member_tags)) {
          this.memberTags = member_tags != null ? JSON.parse(member_tags) : [];
        } else {
          const memberTagsSplit =
            member_tags != null ? member_tags.split(',') : [];

          for (let i = 0; i < memberTagsSplit.length; i++) {
            for (let x = 0; x < this.options.memberTags.length; x++) {
              if (this.options.memberTags[x].name == memberTagsSplit[i]) {
                this.memberTags.push(this.options.memberTags[x].id);
                break;
              }
            }
          }
        }
        // this.memberDataMeta = JSON.parse(data.meta);
        if (typeof this.memberData?.meta !== 'undefined') {
          this.memberDataMeta = this.memberData?.meta || {};
          if (
            typeof this.memberDataMeta === 'string' &&
            this.memberDataMeta !== 'null'
          ) {
            try {
              this.memberDataMeta = JSON.parse(this.memberDataMeta);
            } catch (error) {
              this.memberDataMeta = {};
            }
          }
        }

        // this.memberDataMeta =
        //   typeof this.memberData?.meta !== 'undefined'
        //     ? JSON.parse(this.memberData.meta)
        //     : {};

        this.memberDataRegisteredSite =
          typeof this.memberData?.registeredSite !== 'undefined'
            ? this.memberData.registeredSite
            : {};

        this.birthMonth =
          birth_month != null ? moment(birth_month).format('MM') : null;
        this.birthYear =
          birth_year != null ? moment(birth_year).format('YYYY') : null;
        this.birthDay =
          birth_day != null ? moment(birth_day).format('DD') : null;

        if (mobile_no != null) {
          if (mobile_no != '-1') {
            this.countryCode = mobile_no.substring(0, 3);
            this.mobileNo = mobile_no.substr(-10);
          } else {
            this.countryCode = '+63';
            this.mobileNo = mobile_no;
          }
        }
        if (this.birthMonth == null) {
          this.disableBirthMonth = this.viewMode;
        } else if (!this.selectedActions.includes('Allow Update Birthdate')) {
          `
          this.disableBirthMonth = true;`;
        } else {
          this.disableBirthMonth = this.viewMode;
        }
        if (this.birthDay == null) {
          this.disableBirthDay = this.viewMode;
        } else if (!this.selectedActions.includes('Allow Update Birthdate')) {
          this.disableBirthDay = true;
        } else {
          this.disableBirthDay = this.viewMode;
        }

        if (this.birthYear == null) {
          this.disableBirthYear = this.viewMode;
        } else if (!this.selectedActions.includes('Allow Update Birthdate')) {
          this.disableBirthYear = true;
        } else {
          this.disableBirthYear = this.viewMode;
        }

        if (!this.viewMode) {
          this.setMandatoryFields();
          if (this.formData.region_code == NCR_REGION_CODE) {
            this.isRegionNCR = true;
            this.mandatoryFields.location_province = false;
          } else {
            this.isRegionNCR = false;
            if (
              this.mandatoryFields['location_province'] != undefined &&
              this.mandatoryFields['location_province']
            ) {
              this.mandatoryFields.location_province = true;
            }
          }
        }
        this.formData.member_status_id = member_status_id;
        // this.dynamicFormKey++;
      } else {
        this.clearForm();
        await this.populateDefaultFields();
      }
    },
    isJsonString(str) {
      try {
        let json = JSON.parse(str);
        return typeof json === 'object';
      } catch (e) {
        return false;
      }
    },
    zeroPad(num, places) {
      return String(num).padStart(places, '0');
    },

    async secure() {
      const res = await HTTPRequest.getRequest(
        '/api/v1/clp_members/' + this.memberData.id + '/secure'
      );

      if (res.error) {
        this.$notification.error({
          message: res.error
        });
      } else {
        this.setFormData(res);
        this.canAccessSensitiveInfo = true;
      }
    },

    checkDataDiff(prop = null) {
      const memberData = this.memberData;
      prop != null ? event.target.id : prop;

      if (memberData !== null) {
        const formData = this.formData;
        if (
          prop === 'birth_year' ||
          prop === 'birth_day' ||
          prop === 'birth_month'
        ) {
          const _mDate = moment(memberData[prop]).format('YYYY-MM-DD'),
            _fDate = moment(formData[prop]).format('YYYY-MM-DD');

          if (_mDate != _fDate) {
            this.dataIsChanged = true;
          }
        } else {
          if (memberData[prop] != formData[prop]) {
            this.dataIsChanged = true;
          }
        }
      }
    }
  },
  async created() {
    // console.log('getCardSellingFeature: ', this.getCardSellingFeature());
    this.formLoading = true;
    // Check if there are custom fields or dynamic form
    // if (!this.viewMode) {
    const response = await HTTPRequest.getRequest(
      '/api/v1/clp_account_dynamic_customer_fields'
    );

    if (!response.error) {
      this.dynamic_form = JSON.parse(response.dynamic_form);
    }
    // }

    this.dynamicFormKey++;

    if (!this.viewMode) {
      await this.getMembershipPrograms();
    }
    await this.setFormData(this.memberData);
    this.formLoading = false;
    await this.$store.dispatch('setCurrentModule', 'MemberProfile');
  },

  computed: {
    bdayValidDays() {
      const month = this.birthMonth || null;
      const year = this.birthYear || moment().year();
      let days = 31;
      days = moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();

      return days;
    },
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    }),
    account() {
      return this.$store.state.account;
    },
    // isSuper8() {
    //   const response = ['super8', 'super8-copy'].includes(
    //     this.account.account_name.toLowerCase()
    //   )
    //     ? true
    //     : false;
    //   return response;
    // },
    nullableMobileNumber() {
      if (this.mandatoryFields) {
        if (this.mandatoryFields.allow_null_mobile_no != undefined) {
          return this.mandatoryFields.allow_null_mobile_no;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    subscribeToMarketing: {
      get() {
        return this.formData.marketing_subscription_flag ? true : false;
      },
      set(val) {
        this.formData.marketing_subscription_flag = val;
      }
    }
  },
  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
    this.getMembershipPrograms();
  },

  watch: {
    // memberData: function(data) {
    //   console.log('Watch');
    //   this.setFormData(data);
    // },
    'formData.allow_null_mobile_no': function (newVal) {
      if (newVal != undefined) {
        this.displayAuthActivityModal(newVal);
      }
    },
    'formData.zipcode': function (newVal, oldVal) {
      this.isZipcodeError = false;
      if (newVal != '' && newVal !== oldVal) {
        this.$v.formData.zipcode.$touch();
        if (/^\d+$/.test(newVal) == false) {
          this.isZipcodeError = true;
        }
      }
    },
    memberTags: function (tags) {
      this.formData.member_tags = tags != null ? JSON.stringify(tags) : {};
    },
    'formData.region_code': function (data) {
      if (this.formData.location_region == null) {
        this.options.regions.map((region) => {
          if (region.code == data)
            this.formData.location_region = `${region.regionName} - ${region.name}`;
        });
      }
    },

    drawerVisible: function (val) {
      if (val == false) {
        this.closeDrawer();
      } else {
        if (!this.viewMode) {
          this.getMembershipPrograms();
        }
        if (!this.quickRegistration) {
          this.getRegions();
        }
      }
    },

    birthMonth: function (month) {
      if (month != null) {
        let year = '1900';
        let day = '01';
        this.formData.birth_month = moment(`${year}-${month}-${day}`).format(
          'YYYY-MM-DD'
        );
      } else {
        this.formData.birth_month = null;
      }
      this.validateBirthday();
    },

    birthYear: function (year) {
      if (year != null) {
        let month = '01';
        let day = '01';
        this.formData.birth_year = moment(`${year}-${month}-${day}`).format(
          'YYYY-MM-DD'
        );
      } else {
        this.formData.birth_year = null;
      }
      this.validateBirthday();
    },

    birthDay: function (day) {
      if (day != null) {
        let month = '01';
        let year = '1900';
        this.formData.birth_day = moment(`${year}-${month}-${day}`).format(
          'YYYY-MM-DD'
        );
      } else {
        this.formData.birth_day = null;
      }
    },

    mobileNo: function (mobile) {
      if (mobile != null) {
        this.formData.mobile_no = this.countryCode + mobile;
      } else {
        this.formData.mobile_no = null;
      }
    }
  }
};
</script>

<style scoped></style>
